var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogout = function SvgLogout(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.284,
    height: 20.284,
    viewBox: "0 0 20.284 20.284",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5338",
    "data-name": "Path 5338",
    d: "M12.677,10.991a.845.845,0,0,0-.845.845v3.381a.846.846,0,0,1-.845.845H8.452V3.385A1.7,1.7,0,0,0,7.3,1.778l-.25-.084h3.937a.846.846,0,0,1,.845.845V5.075a.845.845,0,1,0,1.69,0V2.539A2.539,2.539,0,0,0,10.987,0H1.9a.664.664,0,0,0-.09.019C1.771.019,1.732,0,1.69,0A1.692,1.692,0,0,0,0,1.694V16.907a1.7,1.7,0,0,0,1.151,1.607l5.086,1.7a1.75,1.75,0,0,0,.524.079,1.692,1.692,0,0,0,1.69-1.69v-.845h2.535a2.539,2.539,0,0,0,2.535-2.535V11.836A.845.845,0,0,0,12.677,10.991Zm0,0",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5339",
    "data-name": "Path 5339",
    d: "M286.381,110.294,283,106.913a.845.845,0,0,0-1.443.6v2.535h-3.381a.845.845,0,1,0,0,1.69h3.381v2.535a.845.845,0,0,0,1.443.6l3.381-3.381A.844.844,0,0,0,286.381,110.294Zm0,0",
    transform: "translate(-266.345 -102.436)",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logout.49ce636a2629bf4051fc7da1469b8ba5.svg";